import { Flex } from '@chakra-ui/react';

import { MultipleChoicesWidgetToolbarProps } from './MultipleChoicesWidgetToolbar.types';
import SidePanelToggle from './SidePanelToggle';

/**
 * MultipleChoicesWidgetToolbar is the toolbar for the MultipleChoicesWidget
 *
 * @returns
 */
export const MultipleChoicesWidgetToolbar = ({ selectedWidgetType }: MultipleChoicesWidgetToolbarProps) => {
  return (
    <Flex gap='2' align='center' data-testid='statchart-widget-toolbar'>
      <SidePanelToggle />
    </Flex>
  );
};
